export const calculateEffective1RepMax = (weight, repCount) => {
  // The Brzycki Equation : 1RM = w ÷ [(1.0278) – (0.0278 x r)]
  return weight / (1.0278 - 0.0278 * repCount);
};
